import * as allergens from '@/mocks/data/catalogue/products/allergens/list'
import * as managers from '@/mocks/data/park/managers/list'

import { NutriScore, Product } from '@/types/catalogue/product'

export const product1: Product = {
    id: 1,
    name: 'Espresso Coffee',
    client: managers.manager1,
    category: {
        id: 1,
        name: 'Petit déjeuner',
        priority: 1,
    },
    allergens: [allergens.allergen1, allergens.allergen2, allergens.allergen3],
    weight: 300,
    description: 'Un café expresso italien bien corsé.',
    photo: 'https://www.un-amour-de-cafe.com/News/files/Info/image/large/a618e8301fb6d4849d478b6c719101ea.jpg',
    price: 2,
    is_price_weight: false,
    tva: 10,
    nutriscore: NutriScore.enum.D,
    energy_kcal: 10,
    energy_kj: 10,
    fats: 0.1,
    saturated_fats: 0.1,
    sugars: 1,
    fibers: 2,
    proteins: 0.5,
    salt: 0.1,
}

export const product2: Product = {
    id: 2,
    name: 'Croissant',
    client: managers.manager1,
    category: {
        id: 1,
        name: 'Viennoiserie',
        priority: 1,
    },
    allergens: [
        allergens.allergen1,
        allergens.allergen2,
        allergens.allergen3,
        allergens.allergen11,
    ],
    weight: 200,
    description: 'Croissant de chocolat',
    photo: 'https://apis-dev.e-thik.com/media/products/Badoit1.png.200x200_q75.png',
    price: 1.5,
    is_price_weight: false,
    tva: 5,
    nutriscore: NutriScore.enum.D,
    cooking_temp: 60,
    cooking_time: 10,
    energy_kcal: 10,
    energy_kj: 10,
    fats: 0.1,
    saturated_fats: 0.1,
    sugars: 1,
    fibers: 2,
    proteins: 0.5,
    salt: 0.1,
}

export const product3: Product = {
    id: 3,
    name: 'Orange Juice',
    client: managers.manager1,
    category: {
        id: 1,
        name: 'Jus',
        priority: 1,
    },
    allergens: [allergens.allergen11, allergens.allergen3, allergens.allergen7],
    weight: 100,
    description: 'Jus d’orange frais pressé du matin',
    photo: 'https://fr.rc-cdn.community.thermomix.com/recipeimage/90vd41nc-3704c-487912-cfcd2-yt6slisd/b17d91ad-7d45-4918-afe3-d14e942b9b39/main/jus-dorange-rapide.jpg',
    price: 2,
    is_price_weight: false,
    tva: 10,
    nutriscore: NutriScore.enum.C,
    energy_kcal: 10,
    energy_kj: 10,
    fats: 0.1,
    saturated_fats: 0.1,
    sugars: 1,
    fibers: 2,
    proteins: 0.5,
    salt: 0.1,
}

export const product4: Product = {
    id: 4,
    name: 'Barquette de fraise',
    client: managers.manager1,
    category: {
        id: 1,
        name: 'Fruit',
        priority: 1,
    },
    allergens: [],
    weight: 250,
    description: 'Barquette de fraises fermier',
    photo: 'https://vergers-dromois.fr/26-large_default/hummingbird-printed-t-shirt.jpg',
    price: 2,
    is_price_weight: true,
    tva: 10,
    nutriscore: NutriScore.enum.B,
    energy_kcal: 10,
    energy_kj: 10,
    fats: 0.1,
    saturated_fats: 0.1,
    sugars: 1,
    fibers: 2,
    proteins: 0.5,
    salt: 0.1,
}
